import { render, staticRenderFns } from "./CareTeam.vue?vue&type=template&id=c790248e&scoped=true&"
import script from "./CareTeam.vue?vue&type=script&lang=js&"
export * from "./CareTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c790248e",
  null
  
)

export default component.exports